import {
  //new dashboard api calls latest jan 26
  GET_DASHBOARD_ATTENDANCE,
  GET_DASHBOARD_ATTENDANCE_FAILURE,
  GET_DASHBOARD_ATTENDANCE_SUCCESS,
  GET_DASHBOARD_CUSTOMER,
  GET_DASHBOARD_CUSTOMER_FAILURE,
  GET_DASHBOARD_CUSTOMER_SUCCESS,
  GET_DASHBOARD_ESTIMATION,
  GET_DASHBOARD_ESTIMATION_FAILURE,
  GET_DASHBOARD_ESTIMATION_SUCCESS,
  GET_DASHBOARD_JOB_INFO,
  GET_DASHBOARD_JOB_INFO_FAILURE,
  GET_DASHBOARD_JOB_INFO_SUCCESS,
  GET_DASHBOARD_JOB_INFO_CUSTOM,
  GET_DASHBOARD_JOB_INFO_CUSTOM_SUCCESS,
  GET_DASHBOARD_JOB_INFO_CUSTOM_FAILURE,
  GET_DASHBOARD_ORG_SALES,
  GET_DASHBOARD_ORG_SALES_FAILURE,
  GET_DASHBOARD_ORG_SALES_SUCCESS,
  GET_DASHBOARD_PERFORMERS,
  GET_DASHBOARD_PERFORMERS_FAILURE,
  GET_DASHBOARD_PERFORMERS_SUCCESS,
  GET_DASHBOARD_PROJECT_COUNT,
  GET_DASHBOARD_PROJECT_COUNT_FAILURE,
  GET_DASHBOARD_PROJECT_COUNT_SUCCESS,
  GET_DASHBOARD_OPERATION_TOP_SECTION,
  GET_DASHBOARD_OPERATION_TOP_SECTION_FAILURE,
  GET_DASHBOARD_OPERATION_TOP_SECTION_SUCCESS,
  GET_DASHBOARD_RECENT_COMPLETED_JOBS,
  GET_DASHBOARD_SERVICE_TOP_SECTION,
  GET_DASHBOARD_REVENUE_INFO,
  GET_DASHBOARD_COMPLETE_JOB_COMPARE,
  GET_DASHBOARD_ORGANIZATION_JOBS,
  GET_DASHBOARD_TIMESHEET_COUNT,
  GET_DASHBOARD_TIMESHEET_COUNT_FAILURE,
  GET_DASHBOARD_TIMESHEET_COUNT_SUCCESS,
  GET_DASHBOARD_REVENUE_INFO_FAILURE,
  GET_DASHBOARD_REVENUE_INFO_SUCCESS,
} from "../../modules/constants";



// ------------------------------------
// NEw DashBoardActions
// ------------------------------------
export function getDashboardJobInfo(value) {
  return {
    type: GET_DASHBOARD_JOBS_TODAY,
    payload: value,
  };
}

export function getDashboardAttendance(value) {
  return {
    type: GET_DASHBOARD_ATTENDANCE,
    payload: value,
  };
}

export function getDashboardPerformers(value) {
  return {
    type: GET_DASHBOARD_PERFORMERS,
    payload: value,
  };
}

export function getDashboardRevenue(value) {
  return {
    type: GET_DASHBOARD_REVENUE_INFO,
    payload: value,
  };
}

export function getDashboardCompleteJobCompare(value) {
  return {
    type: GET_DASHBOARD_COMPLETE_JOB_COMPARE,
    payload: value,
  };
}

export function getDashboardOrganizationJobs(value) {
  return {
    type: GET_DASHBOARD_ORGANIZATION_JOBS,
    payload: value,
  };
}

export function getDashboardEstimation(value) {
  return {
    type: GET_DASHBOARD_ESTIMATION,
    payload: value,
  };
}

export function getDashboardCustomerPerformance(value) {
  return {
    type: GET_DASHBOARD_CUSTOMER,
    payload: value,
  };
}

export function getDashboardOrganizationSales(value) {
  return {
    type: GET_DASHBOARD_ORG_SALES,
    payload: value,
  };
}

export function getDashboardJobInfoCustom(value) {
  return {
    type: GET_DASHBOARD_JOB_INFO_CUSTOM,
    payload: value,
  };
}

export function getDashboardProjectCount(value) {
  return {
    type: GET_DASHBOARD_PROJECT_COUNT,
    payload: value,
  };
}

export function getDashboardTimesheetCount(value) {
  return {
    type: GET_DASHBOARD_TIMESHEET_COUNT,
    payload: value,
  };
}

export function getDashboardServiceTopSection(value) {
  return {
    type: GET_DASHBOARD_SERVICE_TOP_SECTION,
    payload: value,
  };
}

export function getDashboardOperationTopSection(value) {
  return {
    type: GET_DASHBOARD_OPERATION_TOP_SECTION,
    payload: value,
  };
}

export function getDashboardRecentCompletedJobs(value) {
  return {
    type: GET_DASHBOARD_RECENT_COMPLETED_JOBS,
    payload: value,
  };
}

